module.exports = __webpack_public_path__ + "img/Blumenwiese-1024.22adcddc.jpg";